import COUNTRY_CONSTANT_JSON from '../../../static/country-constant.json';
let COUNTRY_CONSTANT = window._siteProps_?.props?.countryConstant || COUNTRY_CONSTANT_JSON || {};
if(typeof COUNTRY_CONSTANT === "string"){
  COUNTRY_CONSTANT = JSON.parse(COUNTRY_CONSTANT);
}

export const {
  COUNTRY_CODE,
  PHONE_DIGIT,
  CURRENCY_SYMBOL,
  CURRENCY_CODE,
  BLOCKED_PATHS,
  GOOGLE_MAP_COUNTRY,
  DEFAULT_STORE,
  TNC,
  TNC_URL,
  DEFAULT_TNC_URL,
  SHOW_LOAGIN_WITH_PASSWORD,
  DEFAULT_MENU,
  GOOGLE_SITE_VERIFICATION_ID,
  HELP_DESK_NO
} = COUNTRY_CONSTANT;

export const MINIAPP = {
    PAYTM: 'PAYTM',
    GPAY: 'GPAY'
};

export const pendingOrderConstant = {
  headerText: "Order Confirmation in Progress",
  msgText: "99% of our orders get confirmed within 5 mins!",
  failedHeaderText: "Uh-oh! Your Order Failed  ",
  failedMsgText: "Something went wrong. Please try again."
};


export const ORDER_TYPE = {
  DELIVERY: 'D',
  TAKEAWAY: 'T',
  PICKUP: 'P',
  IRCTC: 'IRCTC',
  DINEIN: 'DINEIN',
  CURB: 'CURB'
}


export const ORDER_STATUS_DEL = {
  1: 'Order Confirmed',
  2: 'Being Baked',
  4: 'Dispatched',
  5: 'Cancelled',
  7: 'Ready',
  9: 'Delivered',
  10: 'Advance Order',
  11: 'Reached Gate'
};

export const DELIVERY_TYPE = {
  D : 'delivery' ,
  T: 'takeaway',
  P: 'pickup',
  DINEIN: 'dinein',
  IRCTC: 'IRCTC',
  CURB: 'CURB'
}